<!--
  @author Simeon Artamonov <simeon@cross-works.co.uk>
  @company Cross Works Ltd
-->
<template>
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="instagram-icon"
  >
    <path 
      d="M9.99955 6.67143C8.15678 6.67143 6.67113 8.17143 6.67113 10C6.67113 11.8286 8.17106 13.3286 9.99955 13.3286C11.828 13.3286 13.328 11.8286 13.328 10C13.328 8.17143 11.828 6.67143 9.99955 6.67143ZM19.9991 10C19.9991 8.61429 19.9991 7.25714 19.9277 5.87143C19.8563 4.27143 19.4848 2.84286 18.3135 1.68571C17.1421 0.514286 15.7279 0.142857 14.1279 0.0714285C12.7423 -6.9184e-08 11.3852 0 9.99955 0C8.6139 0 7.25682 -6.9184e-08 5.87117 0.0714285C4.27124 0.142857 2.84273 0.514286 1.68564 1.68571C0.514263 2.85714 0.142851 4.27143 0.0714253 5.87143C-6.91809e-08 7.25714 0 8.61429 0 10C0 11.3857 -6.91809e-08 12.7429 0.0714253 14.1286C0.142851 15.7286 0.514263 17.1571 1.68564 18.3143C2.85702 19.4857 4.27124 19.8571 5.87117 19.9286C7.25682 20 8.6139 20 9.99955 20C11.3852 20 12.7423 20 14.1279 19.9286C15.7279 19.8571 17.1564 19.4857 18.3135 18.3143C19.4848 17.1429 19.8563 15.7286 19.9277 14.1286C20.0134 12.7571 19.9991 11.3857 19.9991 10ZM9.99955 15.1286C7.15682 15.1286 4.87121 12.8429 4.87121 10C4.87121 7.15714 7.15682 4.87143 9.99955 4.87143C12.8423 4.87143 15.1279 7.15714 15.1279 10C15.1279 12.8429 12.8423 15.1286 9.99955 15.1286ZM15.3422 5.85714C14.6851 5.85714 14.1422 5.32857 14.1422 4.65714C14.1422 3.98571 14.6708 3.45714 15.3422 3.45714C16.0136 3.45714 16.5421 3.98571 16.5421 4.65714C16.5457 4.81362 16.5172 4.96918 16.4582 5.11416C16.3992 5.25915 16.3111 5.39048 16.1993 5.5C16.0898 5.61182 15.9584 5.69995 15.8135 5.75893C15.6685 5.81791 15.5129 5.84647 15.3565 5.84286L15.3422 5.85714Z" 
      fill="var(--theme-link)"
    />
  </svg>
</template>


<style lang="scss" scoped>
@use '../../assets/scss/variables' as *;

.instagram-icon path {
  transition: fill $animation-speed-medium ease-out;
}

.instagram-icon:hover path {
  fill: var(--theme-link-hover);
}

.instagram-icon:active path {
  fill: var(--theme-link-active);
}
</style>